import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupAtendimento(): void {
  const modules = [{
    entry: 'historico-protocolos',
    id: 'historico-protocolos',
    name: 'beneficiary.historico-protocolos',
    route: Routes.HISTORICO_PROTOCOLOS,
    order: 1,
    closeable: true,
  }];

  applicationModuleRegistry.registerGroup({
    entry: 'atendimento',
    id: 'atendimento',
    name: 'beneficiary.atendimento',
    modules,
    order: 6,
  });
}
